let registrationExtra = require('../../actions/auth/registration-extra');
let utils = require('../../actions/utils');
let redirect = require('../../actions/redirect');
let cookie = require('../../actions/cookie');
let authGroup = require('../groups/auth');
let analytics = require('../../actions/analytics');
let { selectUserType } = require('../../actions/account/user-form');
let bitrix = require('../../signals/bitrix');

module.exports = {
    showToS: [
        analytics.argsValueEvent({ category: 'popup_agreement', action: 'see' }),
        utils.set(['registrationExtra', 'showToS'], true)
    ],
    cancelToS: [
        utils.set(['registrationExtra', 'showToS'], false),
        registrationExtra.declinePersonalDataProcessing
    ],
    registrationExtra: [
        registrationExtra.acceptPersonalDataProcessing,
        utils.set(['registrationExtra', 'ui', 'registerButton', 'isDisabled'], true),
        // галочки согласия с регистрацией нет, поэтому соглашаемся за пользователя
        utils.set(['registrationExtra', 'form', 'isAcceptPersonalDataProcessing'], true),
        [
            registrationExtra.registerHermesUser, {
                emailAlreadySend: [
                    utils.set(['page', 'name'], 'alert'),
                    utils.set(['auth', 'alert', 'type'], 'registrationSuccess'),
                    analytics.argsValueEvent({ category: 'post_successful_registration', action: 'see' }),
                    cookie.setSessionToken,
                    cookie.unsetRegisterExtraToken,
                    ...authGroup.createOrderAfterLoginIfNeededOrRedirect
                ],
                emailNotConfirmed: [
                    registrationExtra.sendConfirmationMail,
                    utils.set(['page', 'name'], 'alert'),
                    utils.set(['auth', 'alert', 'type'], 'approveRegistration'),
                    analytics.argsValueEvent({ category: 'post_registration_after_email_validation', action: 'see' }),
                    redirect.redirect('/', 15000)
                ],
                passportUserAlreadyAssociated: [
                    utils.set(['registrationExtra', 'error', 'errorType'], 'passportUserAlreadyAssociated')
                ],
                ok: [
                    ...bitrix.getUser,
                    utils.unset(['account', 'orders', 'currentOrder']),
                    utils.unset(['account', 'orders', 'list']),
                    ...authGroup.createOrderAfterLoginIfNeededOrRedirect
                ],
                wrongCountryId: [
                    utils.set(['auth', 'isCountryError'], true)
                ],
                error: [
                    utils.set(['registrationExtra', 'error', 'errorType'], 'internalError')
                ]
            }
        ],
        utils.set(['registrationExtra', 'ui', 'registerButton', 'isDisabled'], false),
        utils.set(['registrationExtra', 'showToS'], false)
    ],
    setRegistrationProperty: [
        registrationExtra.setRegistrationProperty
    ],
    selectUserType: [
        selectUserType(['registrationExtra'])
    ],
    selectCountry: [
        utils.setArgByFunction('selectedValue', (args) => Number(args['selectedValue'])),
        utils.setFromArgsToState('selectedValue', ['registrationExtra', 'form', 'countryId']),
        [
            utils.isEqual(['registrationExtra', 'computed', 'isUserTypeSelectEnabled'], false),
            {
                yes: [
                    utils.set(['registrationExtra', 'form', 'userType'], 1),
                    utils.unset(['registration', 'userTypeRadio']),
                    utils.set(['registrationExtra', 'userTypeRadio', 1], true)
                ],
                no: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/auth/registration-extra.js